<template>
    <div>
        <b-alert :show="!!errorHandlingMessage" variant="danger" dismissible>{{ errorHandlingMessage }}</b-alert>
        <div v-if="hasWorkflows" :class="headerClass">
            <slot name="header" v-bind="{ workflows, loading }"></slot>
        </div>
        <div v-if="hasWorkflows" :class="wrapperClass">
            <slot name="list" v-bind="{ workflows, loading }"></slot>
        </div>
    </div>
</template>

<script>
import { errorHandling } from '../../js/custom-vue-mixins';
import { suppliosApi } from '../../js/api-service';

export default {
    name: 'RfxSourcingWorkflowList',
    components: {},
    mixins: [
        errorHandling,
    ],
    props: {
        rfxId: {
            type: String,
            required: true,
        },
        headerClass: {
            type: [String, Array, Object],
            required: false,
        },
        wrapperClass: {
            type: [String, Array, Object],
            required: false,
        }
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            loading: false,
            workflows: [],  // will pass to default slot
        }
    },
    computed: {
        hasWorkflows() {
            return !!this.workflows && Array.isArray(this.workflows) && this.workflows.length;
        },
    },
    mounted: function() {
        this.getList();
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        async getList() {
            this.loading = true;
            try {
                const resp = await suppliosApi.rfx.get_sourcing_workflow_runs(this.rfxId);
                this.workflows = resp.data;  // not paginated
            } catch (error) {
                this.apiErrorHandler(error);
            }
            this.loading = false;
        }
    }
}
</script>

<style>

</style>